module.exports = __webpack_public_path__ + "img/headMan.91633311.png";